import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  root: {
    width: '1.71em',
    marginRight: theme.spacing(1.25),
    '& svg': {
      height: 'inherit',
      fill: theme.palette.text.disabled,
    },
  },
}))

export default useStyles
